/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'restart': {
    width: 16,
    height: 16,
    viewBox: '0 0 26 30',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#FFF" fill-rule="nonzero" _stroke="#FFF" stroke-width="2"><g><path pid="0" d="M12.558 28.703c-3.1 0-5.974-1.194-8.202-3.39C.223 21.148.352 15.368 2.354 11.461l.872.452c-1.808 3.584-1.97 8.912 1.84 12.722 2.164 2.131 5.038 3.229 8.105 3.067 2.745-.129 5.425-1.291 7.233-3.1 3.713-3.713 4.585-10.72 0-15.305-2.841-2.809-6.716-3.39-9.428-3.035l2.583 2.842-.71.645-3.23-3.551a.491.491 0 0 1 0-.646L12.85 2l.71.646-2.357 2.583c3.003-.323 6.877.42 9.848 3.358 5.005 5.005 4.036 12.657 0 16.694-1.97 1.97-4.908 3.229-7.846 3.358-.226.064-.42.064-.646.064z"/></g></g></g>'
  }
})
